import React, { Children, useEffect, useRef, useState } from "react";
import DrEditor from "./Editor";
import apiCall from "../../../utils/api_call";
import reqOptions from "../../../utils/req_options";
import StatusBox from "./StatusBox";

const api = process.env.API_URL;

/**
 * TO DO: DETERMINE IF THIS SHOULD BE IMPLEMENTED AS CHECKBOX OR RADIO LIST
 * (see Grand Challenges section)
  <EnglishRoutine course_code_a={} editMode={} eng_routine_lookup_id={} />
*/
const EnglishRoutine = (props) => {
  const _isMounted = useRef(false);
  const { containerId, editMode, eng_routine_lookup_id, syllabusId } = props;
  const [routineId, setRoutineId] = useState(eng_routine_lookup_id || null);
  const [routines, setRoutines] = useState([]);
  let routine = { id: null };

  const loadRoutines = () => {
    apiCall(
      `${api}lookup_tables?lookup_table[table_type]=english_routines`,
      reqOptions("GET"),
      { _isMounted: _isMounted.current }
    )
      .then((data) => {
        if (_isMounted.current) {
          setRoutines(data);
        }
      })
      .catch((err) => console.error(err));
  };

  const updateRoutine = (r) => {
    const body = {
      container_id: containerId,
      syllabus: { eng_routine_lookup_id: r.id },
    };
    apiCall(`${api}syllabi/${syllabusId}`, reqOptions("PATCH", body), {
      _isMounted: _isMounted.current,
    })
      .then(null)
      .catch((err) => alert(err));
  };

  const changeRoutine = (e, r) => {
    if (e.target.value === "on") {
      updateRoutine(r);
      if (_isMounted.current) {
        setRoutineId(r.id);
      }
    }
  };

  useEffect(function setMounted() {
    _isMounted.current = true;
    loadRoutines();
    return function setUnmounted() {
      _isMounted.current = false;
    };
  }, []);

  useEffect(
    function routinePropChanged() {
      if (_isMounted.current) {
        setRoutineId(props.eng_routine_lookup_id);
      }
    },
    [props.eng_routine_lookup_id]
  );

  const routineList = routines.map((r) => {
    if (r.id === routineId) routine = r;
    return (
      <DisplayRoutine
        {...props}
        key={`routine-${r.id}`}
        routine={r}
        routineId={routineId}
        changeRoutine={changeRoutine}
      />
    );
  });

  return routineId != null || editMode ? (
    <section id="stem-english-routine" className="top-buffer">
      <h2 className="d-flex flex-row justify-content-between">
        {routineId == null ? "STEM English Routine" : routine.name}
      </h2>
      <h5 className="d-flex flex-row justify-content-left">
        <StatusBox
          {...props}
          index={props.progAIndex}
          sectionName="STEM English Routine Complete?"
          editMode={editMode}
          handleChange={props.toggleProgressA}
        />
      </h5>
      {editMode ? (
        <div className="d-flex flex-row">
          <div className="mr-3">
            <input
              id={`routine-input-none`}
              type="radio"
              name="stem-english-routine"
              checked={routineId === null}
              onChange={(e) => changeRoutine(e, { id: null })}
            />
          </div>
          <label className="card p-3" htmlFor={`routine-input-none`}>
            <h3>None</h3>
          </label>
        </div>
      ) : (
        ""
      )}
      {routineList}
    </section>
  ) : (
    ""
  );
};

/**
 * COMPONENT
 * Represents a single Stem English Routine option.
 **/
const DisplayRoutine = (props) => {
  const _isMounted = useRef(false);
  const { editMode, routineId, routine, changeRoutine } = props;
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    if (_isMounted.current) {
      setExpanded(!expanded);
    }
  };

  useEffect(function setMounted() {
    _isMounted.current = true;
    return function setUnmounted() {
      _isMounted.current = false;
    };
  }, []);

  const radioBtn = editMode ? (
    <div className="mr-3">
      <input
        id={`routine-input-${routine.id}`}
        type="radio"
        name="stem-english-routine"
        checked={routineId == routine.id}
        onChange={(e) => changeRoutine(e, routine)}
      />
    </div>
  ) : (
    ""
  );

  const showHide = expanded ? (
    <div>
      <button className="btn btn-link" onClick={toggleExpanded}>
        Collapse...
      </button>
    </div>
  ) : (
    <div>
      <button className="btn btn-link" onClick={toggleExpanded}>
        Show more...
      </button>
    </div>
  );

  return editMode || routineId === routine.id ? (
    <div className="d-flex flex-row">
      {radioBtn}
      <label className="card p-3" htmlFor={`routine-input-${routine.id}`}>
        <div className="col-11 sm-font">
          {editMode ? (
            <h3 className="d-flex justify-content-between">
              <strong>{routine.name}</strong>
              {showHide}
            </h3>
          ) : (
            ""
          )}
          {expanded || !editMode ? (
            <DrEditor
              text={routine.description}
              dataReady={true}
              focusKey=""
              parentKey="stem-english-routine"
            />
          ) : (
            ""
          )}
        </div>
      </label>
    </div>
  ) : null;
};

export default EnglishRoutine;
